import assests from "../assests";
import AdvertisementIcon from "../icons/AdvertisementIcon";
import AnalysisIcon from "../icons/AnalysisIcon";
import CMSIntegrationIcon from "../icons/CMSIntegrationIcon";
import CustomDesignIcon from "../icons/CustomDesignIcon";
import DigitalConnectionIcon from "../icons/DigitalConnectionIcon";
import DomainIcon from "../icons/DomainIcon";
import EmailCampaignsIcon from "../icons/EmailCampaignsIcon";
import HighPerfomanceIcon from "../icons/HighPerfomanceIcon";
import KeywordResearchIcon from "../icons/KeywordResearchIcon";
import LinkBuildingIcon from "../icons/LinkBuildingIcon";
import ModernUIIcon from "../icons/ModernUIIcon";
import OnPageSEOICON from "../icons/OnPageSEOICON";
import ResponsiveLayoutIcon from "../icons/ResponsiveLayoutIcon";
import ScalibilityIcon from "../icons/ScalibilityIcon";
import SupportIcon from "../icons/SupportIcon";
import TechnicalSEOIcon from "../icons/TechnicalSEOIcon";

/* eslint-disable no-script-url */
export const menuItem = [];

export const whyChooseList = [
  "Tailored Web Design: Every pixel we craft reflects your unique brand identity.",
  "Mobile-First Approach: Seamless experiences across all devices.",
  "SEO & Speed Optimized: Fast-loading, search engine–friendly sites out of the box.",
  "Scalable Solutions: From startups to enterprises, we build for growth.",
  "End-to-End Support: From discovery to deployment – and beyond.",
];

export const cardMock = [
  {
    title: "UI/UX Designing",
    description:
      "We design intuitive, user-friendly interfaces that enhance engagement and ensure a seamless user experience across all devices.",
  },
  {
    title: "App Development",
    description:
      "We build high-performance mobile and web apps tailored to your business needs—fast, scalable, and designed for an exceptional user experience.",
  },
  {
    title: "SEO",
    description:
      "We optimize your website to rank higher on search engines, drive organic traffic, and improve visibility with proven, white-hat SEO strategies.",
  },
  {
    title: "Digital Marketing",
    description:
      "We create data-driven digital marketing campaigns—across social media, search engines, and email—to boost brand awareness, traffic, and conversions.",
  },
];

export const ShrinkCardCompMock = [
  {
    cardImage: assests.cardImg01,
    cardTitle: "Client-Focused Approach",
    cardDescription:
      "We listen, understand, and deliver exactly what your business needs.",
  },
  {
    cardImage: assests.cardImg02,
    cardTitle: "Creative & Innovative",
    cardDescription: "We bring modern, engaging designs to life.",
  },
  {
    cardImage: assests.cardImg03,
    cardTitle: " Technical Excellence",
    cardDescription:
      "Clean code, responsive design, and user-friendly interfaces",
  },
  {
    cardImage: assests.cardImg04,
    cardTitle: "Reliable Partnership",
    cardDescription: "We're with you from concept to launch—and beyond.",
  },
];

export const teamsCardMock = [
  {
    cardImage: assests.CardsImg01,
    name: "Full Name",
    designation: "Designation",
  },
  {
    cardImage: assests.CardsImg01,
    name: "Full Name",
    designation: "Designation",
  },
  {
    cardImage: assests.CardsImg01,
    name: "Full Name",
    designation: "Designation",
  },
  {
    cardImage: assests.CardsImg01,
    name: "Full Name",
    designation: "Designation",
  },
];

export const servicesMock = [
  {
    overlayBgImg: assests.Frameoverlay,
    title: "Web Design & Development",
    descriptionText:
      "We build modern, responsive websites that are visually stunning and functionally powerful—designed to reflect your brand and drive user engagement.",
    btnText: "View all Works",
    designCardData: [
      { detailsText: "Custom Design", icon: <CustomDesignIcon /> },
      { detailsText: "Responsive Layout", icon: <ResponsiveLayoutIcon /> },
      { detailsText: "CMS Integration", icon: <CMSIntegrationIcon /> },
      { detailsText: "Modern UI", icon: <ModernUIIcon /> },
    ],
  },
  {
    overlayBgImg: assests.Frameoverlay01,
    title: "Search Engine Optimization",
    descriptionText:
      "Our SEO strategies help your site rank higher, attract more traffic, and reach the right audience through on-page and off-page optimization.",
    btnText: "View all Works",
    designCardData: [
      { detailsText: "Keyword Research", icon: <KeywordResearchIcon /> },
      { detailsText: "On-Page SEO", icon: <OnPageSEOICON /> },
      { detailsText: "Technical SEO", icon: <TechnicalSEOIcon /> },
      { detailsText: "Link Building", icon: <LinkBuildingIcon /> },
    ],
  },
  {
    overlayBgImg: assests.Frameoverlay02,
    title: "Digital Marketing",
    descriptionText:
      "We create and manage targeted marketing campaigns to build brand awareness, increase conversions, and grow your business.",
    btnText: "View all Works",
    designCardData: [
      { detailsText: "Digital Connection", icon: <DigitalConnectionIcon /> },
      { detailsText: "Email Campaigns", icon: <EmailCampaignsIcon /> },
      { detailsText: "Advertisement", icon: <AdvertisementIcon /> },
      { detailsText: "Analysis", icon: <AnalysisIcon /> },
    ],
  },
  {
    overlayBgImg: assests.Frameoverlay03,
    title: "Complete Web Solutions",
    descriptionText:
      "From concept to launch, we offer end-to-end web solutions that cover every aspect of your online presence.",
    btnText: "View all Works",
    designCardData: [
      { detailsText: "Domain Assist", icon: <DomainIcon /> },
      { detailsText: "100% Support", icon: <SupportIcon /> },
      { detailsText: "High Perfomance", icon: <HighPerfomanceIcon /> },
      { detailsText: "Scalability", icon: <ScalibilityIcon /> },
    ],
  },
];

export const testimonialMock = [
  {
    profileimg: assests.avatarImg01,
    name: "EMiiT",
    descriptionText:
      "You want your testimonials to tell a story about your product and business. You should consider what kind of feelings you want your potential customers to have about your product, ",
  },
  {
    profileimg: assests.avatarImg01,
    name: "EMiiT",
    descriptionText:
      "You want your testimonials to tell a story about your product and business. You should consider what kind of feelings you want your potential customers to have about your product, ",
  },
  {
    profileimg: assests.avatarImg01,
    name: "EMiiT",
    descriptionText:
      "You want your testimonials to tell a story about your product and business. You should consider what kind of feelings you want your potential customers to have about your product, ",
  },
];

export const accordianMockData = [
  {
    id: "01",
    title: "How can i help you",
    content: (
      <>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
        necessitatibus doloribus magni perferendis pariatur dolorum quam debitis
        facere ducimus, consectetur quas natus inventore molestiae assumenda cum
        quos! Hic, impedit soluta!
      </>
    ),
  },
  {
    id: "02",
    title: "How can i help you",
    content: (
      <>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
        necessitatibus doloribus magni perferendis pariatur dolorum quam debitis
        facere ducimus, consectetur quas natus inventore molestiae assumenda cum
        quos! Hic, impedit soluta!
      </>
    ),
  },
  {
    id: "03",
    title: "How can i help you",
    content: (
      <>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
        necessitatibus doloribus magni perferendis pariatur dolorum quam debitis
        facere ducimus, consectetur quas natus inventore molestiae assumenda cum
        quos! Hic, impedit soluta!
      </>
    ),
  },
  {
    id: "04",
    title: "How can i help you",
    content: (
      <>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
        necessitatibus doloribus magni perferendis pariatur dolorum quam debitis
        facere ducimus, consectetur quas natus inventore molestiae assumenda cum
        quos! Hic, impedit soluta!
      </>
    ),
  },
];

export const serviceData = [
  {
    title: "Client-Focused Approach",
    desc: "We listen, understand, and deliver exactly what your business needs.",
    img: assests.cardImg01,
    link: "#web-dev",
  },
  {
    title: "Technical Excellence",
    desc: "Clean code, responsive design, and user-friendly interfaces.",
    img: assests.smallCard01,
    link: "#app-design",
  },
  {
    title: "Reliable Partnership",
    desc: "We're with you from concept to launch—and beyond.",
    img: assests.smallCard02,
    link: "#seo",
  },
  {
    title: "SEO Services",
    desc: "Boost your ranking.",
    img: assests.smallCard03,
    link: "#seo",
  },
];

export const careerCardMock = [
  {
    title: "Web Designer",
    description: "We are Currently Looking for Web Designer ",
    ExperienceLevel: "5-6+",
    JobType: "Full Time",
    Location: "Kolkata",
    Vacancies: "1",
    carrerBgImg: `${assests.careerbg01}`,
  },
  {
    title: "Front-End Developer",
    description: "We are Currently Looking for Front End Developer",
    ExperienceLevel: "5-6+",
    JobType: "Full Time",
    Location: "Kolkata",
    Vacancies: "1",
    carrerBgImg: `${assests.careerbg02}`,
  },
  {
    title: "SEO Specialist",
    description: "We are Currently Looking for SEO Specialist",
    ExperienceLevel: "5-6+",
    JobType: "Full Time",
    Location: "Kolkata",
    Vacancies: "1",
    carrerBgImg: `${assests.careerbg03}`,
  },
  {
    title: "Marketing Executive",
    description: "We are Currently Looking for SEO Specialist",
    ExperienceLevel: "5-6+",
    JobType: "Full Time",
    Location: "Kolkata",
    Vacancies: "1",
    carrerBgImg: `${assests.careerbg04}`,
  },
];

export const EnquiryMock = [
  {
    listTitle: "Partner with EMIIT",
    listDetails:
      "Share your project goals with us using the form below. At EMIIT, we’re committed to transforming your vision into a high-impact digital solution through expert web design, development, SEO, and digital marketing.",
  },
  {
    listTitle: "Fast & Reliable Communication",
    listDetails:
      "We value your time. Our team typically responds within 30 minutes to ensure your questions are answered quickly and efficiently.",
  },
  {
    listTitle: "Partner with EMIIT",
    listDetails:
      "Share your project goals with us using the form below. At EMIIT, we’re committed to transforming your vision into a high-impact digital solution through expert web design, development, SEO, and digital marketing.",
  },
  {
    listTitle: "Confidential & Secure",
    listDetails:
      "Your ideas are safe with us. Every consultation is backed by our strict Non-Disclosure Agreement (NDA), ensuring full confidentiality and trust from the very first conversation.",
  },
];

export const marqueeSlide = [
  assests.facebook,
  assests.instagram,
  assests.youtube,
  assests.linkdin,
  assests.facebook,
  assests.instagram,
  assests.youtube,
  assests.linkdin,
  assests.facebook,
  assests.instagram,
  assests.youtube,
  assests.linkdin,
  assests.facebook,
  assests.instagram,
  assests.youtube,
  assests.linkdin,
  assests.facebook,
  assests.instagram,
  assests.youtube,
  assests.linkdin,
];

export const marqueeSlidemock = [
  assests.facebook01,
  assests.instagram01,
  assests.youtube01,
  assests.linkdin01,
  assests.spotify01,
  assests.facebook01,
  assests.instagram01,
  assests.youtube01,
  assests.linkdin01,
  assests.spotify01,
  assests.facebook01,
  assests.instagram01,
  assests.youtube01,
  assests.linkdin01,
  assests.spotify01,
  assests.facebook01,
  assests.instagram01,
  assests.youtube01,
  assests.linkdin01,
  assests.spotify01,
];

export const viewDesignList = [
  "Determining effective strategies for user-friendly features.",
  "Hire UI/UX designers to improve the application’s strength.",
  "Prioritizing mobile-first approach for seamless navigation.",
  "Increasing user retention and conversion rates with intuitive interfaces.",
];

export const TechnologyCardMock = [
  {
    dataNo: "2024",
    title: "An Expert IT Company",
    description:
      "With over a decade of experience, EMIIT has won prestigious awards, showcasing our commitment to excellence and innovation.",
  },
  {
    dataNo: "700+",
    title: "Professionals",
    description:
      "EMIIT, team of 700+ IT professionals excels in web design, development, mobile apps, and marketing, delivering tailored solutions.",
  },

  {
    dataNo: "8000+",
    title: "Projects Executed",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur necessitatibus doloribus magni perferendis pariatur dolorum quam debitis facere ducimus, consectetur quas natus inventore molestiae assumenda cumquos! Hic, impedit soluta!",
  },

  {
    dataNo: "1500+",
    title: "Clients Worldwide",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur necessitatibus doloribus magni perferendis pariatur dolorum quam debitis facere ducimus, consectetur quas natus inventore molestiae assumenda cumquos! Hic, impedit soluta!",
  },

  {
    dataNo: "98.6%",
    title: "Retention Rate",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur necessitatibus doloribus magni perferendis pariatur dolorum quam debitis facere ducimus, consectetur quas natus inventore molestiae assumenda cumquos! Hic, impedit soluta!",
  },
  {
    dataNo: "4",
    title: "Location Presence",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur necessitatibus doloribus magni perferendis pariatur dolorum quam debitis facere ducimus, consectetur quas natus inventore molestiae assumenda cumquos! Hic, impedit soluta!",
  },
];
